var _path, _path2, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H50V100H8C3.58172 100 0 96.4183 0 92V8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H92C96.4183 0 100 3.58172 100 8V92C100 96.4183 96.4183 100 92 100H50V0Z",
    fill: "#EB443B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 6,
    stroke: "black",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.68 72V27H17.04L26.55 63.09H24.93L34.44 27H40.8V72H34.35V45.78L35.16 45.93L28.05 72H23.43L16.32 45.93L17.13 45.78V72H10.68Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.92 59.76V61.86C83.92 65.18 82.93 67.86 80.95 69.9C78.97 71.94 76.31 72.96 72.97 72.96C69.65 72.96 66.99 71.94 64.99 69.9C63.01 67.86 62.02 65.18 62.02 61.86V37.14C62.02 33.8 63.01 31.12 64.99 29.1C66.99 27.06 69.65 26.04 72.97 26.04C76.31 26.04 78.97 27.06 80.95 29.1C82.93 31.12 83.92 33.8 83.92 37.14V39.24H77.02V37.14C77.02 35.88 76.66 34.87 75.94 34.11C75.22 33.33 74.23 32.94 72.97 32.94C71.71 32.94 70.72 33.33 70 34.11C69.28 34.87 68.92 35.88 68.92 37.14V61.86C68.92 63.12 69.28 64.14 70 64.92C70.72 65.68 71.71 66.06 72.97 66.06C74.23 66.06 75.22 65.68 75.94 64.92C76.66 64.14 77.02 63.12 77.02 61.86V59.76H83.92Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogo);
export default __webpack_public_path__ + "static/media/square-logo.e2f57f1bab3923df3d1de02211d2c3b9.svg";
export { ForwardRef as ReactComponent };